module.exports = __webpack_public_path__ + "img/safety-homepage-hover.9a7c0340.png";